export default __webpack_public_path__ + "static/media/ifba.87d67dee.png";